<template>
  <div>
    <top-bar :heading="course.name"></top-bar>
    <loading-spinner :loading="!$store.state.studentCourses.length"></loading-spinner>
    <div class="container-fluid mt-3" v-if="$store.state.studentCourses.length">
      <div>
        <b-card no-body header="Unit Overview" class="h-100">
          <b-card-body class="p-3">
            <div v-html="course.description"></div>
          </b-card-body>
        </b-card>
      </div>
      <div v-for="module in course.user_modules" :key="'module-' + module.id" class="mb-5">
        <b-card no-body>
          <b-card-header :class="{'bg-success': module.is_complete}">
            {{ module.name }}
          </b-card-header>
          <b-card-body class="p-0">
            <table class="table table-hover table-responsive-sm table-responsive-md m-0">
              <tbody>
                <tr v-if="module.description">
                  <td colspan="4" class="text-center">
                    {{ module.description }}
                  </td>
                </tr>
                <tr v-for="section in module.user_sections" :key="'section-' + section.id">
                  <td width="10%">
                    <span class="badge badge-success p-1" style="width: 21px; height: 21px;" v-if="section.is_complete"><font-awesome-icon icon="check"></font-awesome-icon></span>
                    <span class="badge badge-warning p-1" style="width: 21px; height: 21px;" v-else-if="section.has_submission"><font-awesome-icon icon="question"></font-awesome-icon></span>
                    <span class="badge badge-danger p-1 text-white" style="width: 21px; height: 21px;" v-else><font-awesome-icon icon="times"></font-awesome-icon></span>
                  </td>
                  <td>{{ section.name }}</td>
                  <td width="30%">
                    <template v-if="!section.section.is_form">
                      <router-link class="btn btn-success btn-block" v-if="section.is_complete" :to="'/training/' + section.section_id">Completed: {{ section.completed_at | moment('Do MMM, Y') }}</router-link>
                      <router-link class="btn btn-block btn-danger" v-else-if="!section.has_submission" :to="'/training/' + section.section_id">Open</router-link>
                      <router-link class="btn btn-block btn-warning" v-else-if="section.has_submission" :to="'/training/' + section.section_id">Submitted, Not Graded</router-link>
                    </template>
                    <template v-else-if="section.section.is_form">
                      <router-link class="btn btn-success btn-block" v-if="section.is_complete" :to="'/assignment/' + section.section.form_id">Completed: {{ section.completed_at | moment('Do MMM, Y') }}</router-link>
                      <router-link class="btn btn-block btn-danger" v-else-if="!section.has_submission" :to="'/assignment/' + section.section.form_id">Open</router-link>
                      <router-link class="btn btn-block btn-warning" v-else-if="section.has_submission" :to="'/assignment/' + section.section.form_id">Submitted, Not Graded</router-link>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainingModules',
  data () {
    return {};
  },
  methods: {},
  mounted () {
    this.$store.dispatch('LOAD_USER_COURSES', this);
  },
  computed: {
    course () {
      return this.$store.state.studentCourses.find(x => x.course_id === parseInt(this.id));
    }
  },
  metaInfo: {
    title: 'Modules'
  },
  props: ['id']
};
</script>
